import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { Movie } from '@/types/content';
import MovieCard from '@/components/feature/MovieCard';

interface HotMoviesProps {
  movies: Movie[];
}

const tabs = [
  { key: 'hot', label: '热度榜' },
  { key: 'rating', label: '评分榜' },
  { key: 'new', label: '最新上线' },
];

export default function HotMovies({ movies }: HotMoviesProps) {
  const [tab, setTab] = useState('hot');

  const sorted = [...movies].sort((a, b) => {
    if (tab === 'rating') return b.rating - a.rating;
    if (tab === 'new') return b.year - a.year;
    return b.heat - a.heat;
  });
  const list = sorted.slice(0, 8);

  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门影视推荐</h2>
            <p className="mt-1 text-sm text-foreground-500">精选当下最受欢迎的影视作品，看看大家都在追什么</p>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1 rounded-full bg-background-200 p-1">
              {tabs.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => setTab(item.key)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                    tab === item.key
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <Link
              to="/category"
              className="hidden cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 md:flex"
            >
              更多
              <i className="ri-arrow-right-s-line" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {list.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}